var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCornNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 29,
    viewBox: "0 0 38 29",
    width: 38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.455 27.2602c-.3563.5303-.8703.9706-1.4901 1.2761-.6197.3056-1.323.4655-2.0385.4637h-29.85681c-.71548.0023-1.41892-.1573-2.03891-.4625-.61998-.3052-1.134413-.7452-1.491062-1.2753-.356648-.5301-.5428088-1.1314-.53957662-1.7429.00323219-.6115.19574162-1.2113.55797962-1.7386l14.911479-22.03706c.357-.53001.8711-.970242 1.4906-1.276353.6194-.306112 1.3224-.467287 2.0379-.467287.7156 0 1.4185.161175 2.038.467287.6194.306111 1.1336.746343 1.4906 1.276353l14.9114 22.03706c.365.5262.559 1.1261.562 1.7378.0029.6117-.1852 1.2129-.545 1.7417z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornNav);
export default __webpack_public_path__ + "static/media/cornNav.00df8f938e633e43a4a12ee3f7520784.svg";
export { ForwardRef as ReactComponent };